import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { DistinctValue } from "../../../types";
import TableAutocomplete from "../../shared/table-autocomplete";
import FieldAutocomplete from "../../shared/field-autocomplete";
import useReclassifyValues from "./hooks/use-reclassify-values";

interface ReclassifyValuesFooterProps {
  fieldId: number | undefined;
  checked: { [key: string]: boolean };
  mainValues: DistinctValue[];
  selectedItem: DistinctValue | null;
  refreshDistinctValues: () => void;
}

/**
 * Footer for Reclassify Values category (categoryId: 2)
 */
const ReclassifyValuesFooter: React.FC<ReclassifyValuesFooterProps> = ({
  fieldId,
  checked,
  mainValues,
  selectedItem,
  refreshDistinctValues,
}) => {
  const {
    targetTable,
    targetField,
    availableTables,
    fieldsForEntity,
    valuesToReclassify,
    message,
    setTargetTable,
    setTargetField,
    handleReclassify,
    handleCancel,
  } = useReclassifyValues({
    fieldId,
    checked,
    mainValues,
    selectedItem,
    refreshDistinctValues,
  });

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderTop: "1px solid #eee",
          p: 2,
          maxHeight: "400px",
          overflowY: "auto",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {message}
        </Typography>

        <TableAutocomplete
          options={availableTables || []}
          value={targetTable}
          onTableChange={(table) => {
            setTargetTable(table);
            setTargetField(null); // Reset field when entity changes
          }}
        />

        <FieldAutocomplete
          options={fieldsForEntity || []}
          value={targetField}
          onFieldChange={setTargetField}
          disabled={!targetTable}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          borderTop: "1px solid #eee",
          p: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mr: 1, borderRadius: 1 }}
          onClick={handleReclassify}
          disabled={valuesToReclassify.length === 0}
        >
          Reclassify
        </Button>
        <Button
          variant="outlined"
          size="small"
          sx={{ borderRadius: 1 }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ReclassifyValuesFooter;
